import styled, { css } from 'styled-components';
import { PanelStyledProps } from './Panel.type';
import { forEachBreakpoint, SpacingValue } from 'styled-system';

const getPanelPadding = (props: PanelStyledProps) => {
  let styles = '';

  forEachBreakpoint((breakpoint) => {
    if (Array.isArray(props.spacing[breakpoint])) {
      const [paddingX, paddingY] = props.spacing[breakpoint] as [
        SpacingValue,
        SpacingValue,
      ];
      styles += `
        @media only screen and (min-width: ${props.theme.breakpoints[breakpoint]}px) {
          padding: ${paddingX}px ${paddingY}px;
        }
      `;
    } else {
      styles += `
        @media only screen and (min-width: ${
          props.theme.breakpoints[breakpoint]
        }px) {
              padding: ${
                props.theme.spacing[props.spacing[breakpoint] as SpacingValue]
              };
        }
      `;
    }
  });

  return css`
    ${styles}
  `;
};

const getPanelBase = (props: PanelStyledProps) => {
  const { background, boxShadow, borderRadius } =
    props.theme.components.panel.base;
  return `
  width: 100%;
    background: ${background};
  box-shadow: ${boxShadow};
  border-radius: ${borderRadius};
  `;
};

const Panel = styled.div<PanelStyledProps>((props) => {
  return css`
    ${getPanelBase};
    ${getPanelPadding(props)};
  `;
});

export { Panel };
